import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { Card, Badge, EmptyState } from "../AdminUI";

export default function PaymentRequests() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/payment-requests").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Payment Requests</h1>
      <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
        <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" />
        <span>Clients who submitted billing information or authorized payment appear here. Complete the charge through your approved offline terminal, then open the invoice to record the result. Secure card collection stays disabled until a PCI-compliant vault is connected in Billing Settings.</span>
      </div>
      <Card>
        {rows.length === 0 ? <EmptyState icon={CreditCard} title="No pending payment requests" /> : (
          <div className="divide-y divide-gray-100">
            {rows.map((i) => (
              <Link to="/admin/invoices" key={i.id} className="flex items-center justify-between py-3 hover:bg-gray-50 px-2 -mx-2 rounded" data-testid={`request-${i.invoice_number}`}>
                <div><p className="font-semibold text-[var(--navy)]">{i.invoice_number} · {i.customer_name}</p>
                  <p className="text-xs text-gray-400">Balance ${i.balance_due?.toFixed(2)} · updated {new Date(i.last_updated).toLocaleString()}</p></div>
                <Badge color="amber">{i.status}</Badge>
              </Link>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
